// extracted by mini-css-extract-plugin
module.exports = {"contetntCard":"XyzPlusContentCardUi__contetntCard__3y3Jd","title":"XyzPlusContentCardUi__title__3imkD","label":"XyzPlusContentCardUi__label__19Y2X"};